import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import '../css/Formviewer.css';
import { apiEndpoints, toggleEndpoints, updateEndpoints, updateImageEndpoints, uploadEndpoints, defaultStructure } from './Constants';

const Formviewer = ({ formName, onBack }) => {
  const [data, setData] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editData, setEditData] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [uploadData, setUploadData] = useState({});

  let selectedImageId = '';
  let selectedImageField = '';

  const handleUploadSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in uploadData) {
      formData.append(key, uploadData[key]);
    }

    Swal.fire({
      title: 'Uploading...',
      text: 'Please wait while the data is being uploaded.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const res = await fetch(uploadEndpoints[formName], {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });

      const data = await res.json();

      if (res.ok && data.message?.toLowerCase().includes('success')) {
        Swal.fire({
          icon: 'success',
          title: 'Upload Successful',
          text: data.message + (data.warnings?.length ? '\n' + data.warnings.join('\n') : ''),
        });
        setIsUploadModalOpen(false);
        setUploadData({});
        fetchData(apiEndpoints[formName]);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: data.error,
        });
      }
    } catch (error) {
      console.error('Upload network error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'Upload failed. Please try again.',
      });
    }
  };

  const renderUploadModal = () => {
    if (!isUploadModalOpen) return null;

    return (
      <div className="modal-overlay11">
        <div className="modal-content11">
          <h3><strong>New Entry - {formName}</strong></h3>
          {formName === 'Upcoming Events' && (
            <h5>
              Format for questions:-<br />
              Text - your_question<br />
              Radio - your_question {'{"option1", "option2", "option3"}'}<br />
              Rating - your_question<br />
              MCQ - your_question {'{"option1", "option2", "option3"}'}<br /><br />
              <br />
            </h5>
          )}
          {formName === 'Certificates' && (
            <h5>
              Format for Certificate Name:- eventID_userID.pdf<br></br>
              <br />
              Zip Name can be anything but short and descriptive<br />
              <br />
            </h5>
          )}
          {formName === 'Valumni' && (
            <h5>
              Format for tags:-<br />
              {'{"tag1", "tag2", "tag3"}'}<br />
              <br />
            </h5>
          )}
          <form onSubmit={handleUploadSubmit}>
            {Object.keys(defaultStructure[formName] || {}).map((key) => {
              if (
                key === 'id' ||
                key === 'created_at' ||
                /^questionType\d+$/.test(key) ||
                /^qmand\d+$/.test(key)
              ) return null;

              if (formName === 'CA Queries' && key === 'query_no') {
                return (
                  <div key={key}>
                    <label><strong>Query No:</strong></label>
                    <input
                      type="number"
                      name={key}
                      value={uploadData[key] || ''}
                      onChange={(e) =>
                        setUploadData({ ...uploadData, [e.target.name]: e.target.value })
                      }
                    />
                  </div>
                );
              }

              // Handle Upcoming Events special fields
              if (formName === 'Upcoming Events' && /^question\d+$/.test(key)) {
                const index = key.match(/\d+/)[0]; // get number
                const typeKey = `questionType${index}`;
                const mandKey = `qmand${index}`;

                return (
                  <div key={key} className="question-group-row">
                    <label><strong>{key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}:</strong></label>
                    <input
                      type="text"
                      name={key}
                      value={uploadData[key] || ''}
                      onChange={(e) => setUploadData({ ...uploadData, [e.target.name]: e.target.value })}
                    />

                    <select
                      name={typeKey}
                      value={uploadData[typeKey] || ''}
                      onChange={(e) => setUploadData({ ...uploadData, [e.target.name]: e.target.value })}
                    >
                      <option value="text">Text</option>
                      <option value="radio">Radio</option>
                      <option value="rating">Rating</option>
                      <option value="mcq">MCQ</option>
                    </select>

                    <button
                      type="button"
                      className="hideshow-btn"
                      style={{ marginLeft: '10px' }}
                      onClick={() =>
                        setUploadData({ ...uploadData, [mandKey]: uploadData[mandKey] === '1' ? '0' : '1' })
                      }
                    >
                      {uploadData[mandKey] === '1' ? 'Click to make it Optional' : 'Click to make it Mandatory'}
                    </button>

                  </div>
                );
              }

              if (formName === 'Upcoming Events' && key === 'isOpen') {
                return (
                  <div key={key}>
                    <label><strong>{key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}:</strong></label>
                    <button
                      type="button"
                      className="hideshow-btn"
                      onClick={() =>
                        setUploadData({ ...uploadData, [key]: uploadData[key] === '1' ? '0' : '1' })
                      }
                    >
                      {uploadData[key] === '1' ? 'Click to Close Form' : 'Click to Open Form'}
                    </button>
                  </div>
                )
              }

              if (key === 'college' || key === 'area' || key === 'visit_url') {
                if (!uploadData.college) {
                  setUploadData(prev => ({ ...prev, college: 'main' }));
                }
                return (
                  <div key={key}>
                    <label><strong>{key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}:</strong></label>
                    <select
                      name={key}
                      value={uploadData[key] || ''}
                      style={{ marginBottom: '10px', width: '250px' }}
                      onChange={(e) => setUploadData({ ...uploadData, [e.target.name]: e.target.value })}
                    >
                      <option value="main">main</option>
                      <option value="HRC">HRC</option>
                      <option value="RJC">RJC</option>
                      <option value="JCBUST">JCBUST</option>
                      <option value="CLC">CLC</option>
                    </select>
                  </div>
                )
              }

              if (key === 'date' || key === 'report_date') {
                const today = new Date().toISOString().split('T')[0];

                if (!uploadData.date) {
                  setUploadData(prev => ({ ...prev, date: today }));
                }

                return (
                  <div key={key}>
                    <label><strong>Date:</strong></label>
                    <input
                      type="date"
                      name={key}
                      value={uploadData[key] || today}
                      style={{ marginBottom: '10px', width: '200px' }}
                      onChange={(e) =>
                        setUploadData({ ...uploadData, [e.target.name]: e.target.value })
                      }
                    />
                  </div>
                );
              }

              if (formName === 'Camp Reviews' && key == 'position') {
                if (!uploadData.position) {
                  setUploadData(prev => ({ ...prev, position: 'top' }));
                }
                return (
                  <div key={key}>
                    <label><strong>{key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}:</strong></label>
                    <select
                      name={key}
                      value={uploadData[key] || ''}
                      style={{ marginBottom: '10px', width: '200px' }}
                      onChange={(e) => setUploadData({ ...uploadData, [e.target.name]: e.target.value })}
                    >
                      <option value="top">top</option>
                      <option value="bottom">bottom</option>
                    </select>
                  </div>
                )
              }

              if (formName === 'Certificates' && (key === 'user_id' || key === 'event_id' || key === 'isShown')) {
                return null;
              }

              if (formName === 'Certificates' && key === 'certificate_path') {
                return (
                  <div key={key}>
                    <label><strong>Certificate Zip File:</strong></label>
                    <input
                      type="file"
                      name="cert_zip"
                      accept=".zip"
                      onChange={(e) =>
                        setUploadData({ ...uploadData, "cert_zip": e.target.files[0] })
                      }
                    />
                  </div>
                );
              }

              // All other fields (existing code)
              return (
                <div key={key}>
                  <label>
                    <strong>{key === 'isShown' ? 'Display' : key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}:</strong>
                  </label>
                  {key.toLowerCase().includes('image') || key.toLowerCase().includes('photo') ? (
                    <input
                      type="file"
                      name={key}
                      accept="image/jpeg,image/png"
                      onChange={(e) =>
                        setUploadData({ ...uploadData, [e.target.name]: e.target.files[0] })
                      }
                    />
                  ) : key.toLowerCase().includes('pdf') ? (
                    <input
                      type="file"
                      name={key}
                      accept="application/pdf"
                      onChange={(e) =>
                        setUploadData({ ...uploadData, [e.target.name]: e.target.files[0] })
                      }
                    />
                  ) : key === 'isShown' ? (
                    <button
                      type="button"
                      className="hideshow-btn"
                      onClick={() =>
                        setUploadData({ ...uploadData, isShown: uploadData.isShown === '1' ? '0' : '1' })
                      }
                    >
                      {uploadData.isShown === '1' ? 'Click to hide' : 'Click to show'}
                    </button>
                  ) : (
                    <input
                      type="text"
                      name={key}
                      value={uploadData[key] || ''}
                      onChange={(e) =>
                        setUploadData({ ...uploadData, [e.target.name]: e.target.value })
                      }
                    />
                  )}
                </div>
              );
            })}
            <div style={{ marginTop: '20px' }}>
              <button type="submit">Upload</button>
              <button type="button" className="cancel" onClick={() => setIsUploadModalOpen(false)}>Cancel</button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  const handleImageUpdate = async (event) => {
    const file = event.target.files[0];
    if (!file || !selectedImageId || !selectedImageField) return;

    const formData = new FormData();
    formData.append('id', selectedImageId);
    formData.append(selectedImageField, file);

    Swal.fire({
      title: 'Uploading...',
      text: 'Please wait while the data is being updated.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const res = await fetch(updateImageEndpoints[formName], {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });

      const data = await res.json();

      if (res.ok && data.message?.toLowerCase().includes('success')) {
        Swal.fire({
          icon: 'success',
          title: 'Update Successful',
          text: data.message,
        });
        fetchData(apiEndpoints[formName]);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Update Failed',
          text: data.error,
        });
      }
    } catch (error) {
      console.error('Upload network error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'Upload failed. Please check your network connection and try again.',
      });
    }
  };

  useEffect(() => {
    if (formName && apiEndpoints[formName]) {
      fetchData(apiEndpoints[formName]);
    }
  }, [formName]);

  const fetchData = async (url) => {
    try {
      const response = await fetch(url);
      const jsonData = await response.json();
      setData(jsonData);
    } catch (error) {
      console.error(`Error fetching ${formName} data:`, error);
    }
  };

  const handleToggleIsOpen = async (id, currentValue) => {
    const newValue = currentValue == 1 ? 0 : 1;

    // Show loading spinner
    Swal.fire({
      title: 'Updating...',
      text: 'Please wait while the status is being updated.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    // Placeholder for API call — you'll give the actual endpoint
    try {
      const response = await fetch('https://ethiccraft.org/backend/upcoming_events/toggleOpen.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id, isOpen: newValue }),
        credentials: 'include',
      });

      if (!response.ok) throw new Error('Toggle failed');

      Swal.fire({
        icon: 'success',
        title: 'Status Updated',
        text: data.message || 'Visibility status updated successfully.',
      });

      // Refresh data after toggle
      fetchData(apiEndpoints[formName]);
    } catch (err) {
      console.error('Toggle error:', err);
      Swal.fire({
        icon: 'error',
        title: 'Update Failed',
        text: data.message || 'Something went wrong while updating status.',
      });
    }
  };

  const handleToggleShown = async (id, currentStatus) => {
    const newStatus = currentStatus === '1' ? '0' : '1';
    const formData = new FormData();
    formData.append('id', id);
    formData.append('isShown', newStatus);

    // Show loading spinner
    Swal.fire({
      title: 'Updating...',
      text: 'Please wait while the status is being updated.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const res = await fetch(toggleEndpoints[formName], {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });

      const data = await res.json();

      if (res.ok || data.message?.toLowerCase().includes('success')) {
        Swal.fire({
          icon: 'success',
          title: 'Update Successful',
          text: data.message,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Update Failed',
          text: data.error,
        });
      }

      fetchData(apiEndpoints[formName]); // Refresh data after update
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'Failed to update status. Please try again.',
      });
    }
  };

  const handleDownloadExcel = () => {
    if (data.length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'No Data',
        text: 'There is no data to download.',
      });
      return;
    }

    // Show loading spinner
    Swal.fire({
      title: 'Generating Excel...',
      text: 'Please wait while the file is being prepared.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    setTimeout(() => {
      try {
        // Dynamically get all unique keys from the dataset
        const allKeys = Array.from(
          data.reduce((keys, item) => {
            Object.keys(item).forEach(key => keys.add(key));
            return keys;
          }, new Set())
        );

        // Map data according to all keys
        const cleanedData = data.map(item => {
          const row = {};
          allKeys.forEach(key => {
            if (
              key.includes('image') ||
              key.includes('photo') ||
              key.includes('banner') ||
              key.includes('pdf') ||
              key.includes('certificate_path')
            ) {
              row[key] = item[key]
                ? formName === 'Certificates' && key === 'certificate_path'
                  ? `https://ethiccraft.org/${item[key].replace(/^.*?uploads\//, 'uploads/')}`
                  : `https://ethiccraft.org/${item[key]}`
                : '';
            }
            else if (key === 'isShown') {
              row[key] = item[key] === '1' ? 'Shown' : 'Hidden';
            } else {
              row[key] = item[key];
            }
          });
          return row;
        });

        // Create worksheet and download Excel
        const worksheet = XLSX.utils.json_to_sheet(cleanedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, formName);
        XLSX.writeFile(workbook, `${formName}_data.xlsx`);

        Swal.fire({
          icon: 'success',
          title: 'Download Ready',
          text: 'Excel file downloaded successfully.',
        });
      } catch (error) {
        console.error('Download error:', error);
        Swal.fire({
          icon: 'error',
          title: 'Download Failed',
          text: 'Something went wrong while creating the Excel file.',
        });
      }
    }, 500); // Delay added to allow spinner to show
  };

  const renderToggleButton = (id, isShown) => (
    <button
      onClick={() => handleToggleShown(id, isShown)}
      className='row-btn'
    >
      {isShown === '1' ? 'Hide' : 'Show'}
    </button>
  );

  const renderOpenCloseButton = (id, isOpen) => (
    <button
      onClick={() => handleToggleIsOpen(id, isOpen)}
      className="row-btn"
    >
      {isOpen === '1' ? 'Close' : 'Open'}
    </button>
  );

  const handleEditClick = (row) => {
    setSelectedRow(row);
    setEditData(row);
    setIsEditModalOpen(true);
  };

  const handleEditChange = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in editData) {
      formData.append(key, editData[key]);
    }

    // Show SweetAlert loading spinner
    Swal.fire({
      title: 'Updating...',
      text: 'Please wait while the data is being saved.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const res = await fetch(updateEndpoints[formName], {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });

      const data = await res.json();

      if (res.ok && data.message?.toLowerCase().includes('success')) {
        Swal.fire({
          icon: 'success',
          title: 'Update Successful',
          text: data.message,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Update Failed',
          text: data.error,
        });
      }

      setIsEditModalOpen(false);
      fetchData(apiEndpoints[formName]); // Refresh table data
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'Failed to update status. Please try again.',
      });
    }
  };

  const renderEditModal = () => {
    if (!isEditModalOpen || !selectedRow) return null;

    return (
      <div className="modal-overlay11">
        <div className="modal-content11">
          <h3><strong>Edit</strong></h3>
          {formName === 'Upcoming Events' && (
            <h5>
              Format for questions:-<br />
              Text - your_question<br />
              Radio - your_question {'{"option1", "option2", "option3"}'}<br />
              Rating - your_question<br />
              MCQ - your_question {'{"option1", "option2", "option3"}'}<br /><br />
              <br />
            </h5>
          )}
          {formName === 'Certificates' && (
            <h5>
              Format for Certificate Name:- eventID_userID.pdf<br></br>
              <br />
              Zip Name can be anything but short and descriptive<br />
              <br />
            </h5>
          )}
          {formName === 'Valumni' && (
            <h5>
              Format for tags:-<br />
              {'{"tag1", "tag2", "tag3"}'}<br />
              <br />
            </h5>
          )}
          <form onSubmit={handleEditSubmit}>
            {Object.keys(selectedRow).map((key) => {
              if (key === 'id' ||
                key === 'created_at' ||
                key.includes('image') ||
                key.includes('photo') ||
                key.includes('pdf_link') ||
                key.includes('Shown') ||
                key.includes('isOpen') ||
                /^questionType\d+$/.test(key) ||
                /^qmand\d+$/.test(key)) {
                return null;
              }

              // Handle Upcoming Events special fields
              if (formName === 'Upcoming Events' && /^question\d+$/.test(key)) {
                const index = key.match(/\d+/)[0]; // get number
                const typeKey = `questionType${index}`;
                const mandKey = `qmand${index}`;

                return (
                  <div key={key} className="question-group-row">
                    <label><strong>{key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}:</strong></label>
                    <input
                      type="text"
                      name={key}
                      value={editData[key] || ''}
                      onChange={(e) => setEditData({ ...editData, [e.target.name]: e.target.value })}
                    />

                    <select
                      name={typeKey}
                      value={editData[typeKey] || ''}
                      onChange={(e) => setEditData({ ...editData, [e.target.name]: e.target.value })}
                    >
                      <option value="text">Text</option>
                      <option value="radio">Radio</option>
                      <option value="rating">Rating</option>
                      <option value="mcq">MCQ</option>
                    </select>

                    <button
                      type="button"
                      className="hideshow-btn"
                      style={{ marginLeft: '10px' }}
                      onClick={() =>
                        setEditData({ ...editData, [mandKey]: editData[mandKey] === '1' ? '0' : '1' })
                      }
                    >
                      {editData[mandKey] === '1' ? 'Click to make it Optional' : 'Click to make it Mandatory'}
                    </button>

                  </div>
                );
              }

              if (formName === 'Upcoming Events' && key == 'isOpen') {
                return (
                  <div key={key}>
                    <label><strong>{key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}:</strong></label>
                    <button
                      type="button"
                      className="hideshow-btn"
                      onClick={() =>
                        setEditData({ ...editData, [key]: editData[key] === '1' ? '0' : '1' })
                      }
                    >
                      {editData[key] === '1' ? 'Click to Close Form' : 'Click to Open Form'}
                    </button>
                  </div>
                )
              }

              if (key === 'college' || key === 'area' || key === 'visit_url') {
                return (
                  <div key={key}>
                    <label><strong>{key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}:</strong></label>
                    <select
                      name={key}
                      value={editData[key] || ''}
                      style={{ marginBottom: '10px', width: '250px' }}
                      onChange={(e) => setEditData({ ...editData, [e.target.name]: e.target.value })}
                    >
                      <option value="main">main</option>
                      <option value="HRC">HRC</option>
                      <option value="RJC">RJC</option>
                      <option value="JCBUST">JCBUST</option>
                      <option value="CLC">CLC</option>
                    </select>
                  </div>
                )
              }

              if (key === 'date' || key === 'report_date') {
                return (
                  <div key={key}>
                    <label><strong>Date:</strong></label>
                    <input
                      type="date"
                      name={key}
                      value={editData[key] || ''}
                      style={{ marginBottom: '10px', width: '200px' }}
                      onChange={(e) => setEditData({ ...editData, [e.target.name]: e.target.value })}
                    />
                  </div>
                );
              }

              if (formName === 'CA Queries' && key === 'query_no') {
                return (
                  <div key={key}>
                    <label><strong>Query No:</strong></label>
                    <input
                      type="number"
                      name={key}
                      value={editData[key] || ''}
                      onChange={(e) => setEditData({ ...editData, [e.target.name]: e.target.value })}
                    />
                  </div>
                );
              }

              if (formName === 'Camp Reviews' && key == 'position') {
                return (
                  <div key={key}>
                    <label><strong>{key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}:</strong></label>
                    <select
                      name={key}
                      value={editData[key] || ''}
                      style={{ marginBottom: '10px', width: '200px' }}
                      onChange={(e) => setUploadData({ ...uploadData, [e.target.name]: e.target.value })}
                    >
                      <option value="top">top</option>
                      <option value="bottom">bottom</option>
                    </select>
                  </div>
                )
              }

              return (
                <div key={key}>
                  <label>
                    <strong>{key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}:</strong>
                  </label>
                  <input
                    type="text"
                    name={key}
                    value={editData[key] || ''}
                    onChange={handleEditChange}
                  />
                </div>
              );
            })}
            <div style={{ marginTop: '20px' }}>
              <button type="submit">Save</button>
              <button type="button" className="cancel" onClick={() => setIsEditModalOpen(false)}>Cancel</button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  return (
    <div>
      {renderUploadModal()}
      {renderEditModal()}
      <div className="form-details-section">
        <h2>{formName} Details</h2>
        <div className="form-header">
          <button onClick={onBack} className="back-btn">Back</button>
            <input
              type="text"
              className="search-input"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          {!['Campus Ambassador', 'Event Bookings', 'User Profiles'].includes(formName) && (
            <button onClick={() => setIsUploadModalOpen(true)} className="new-btn">New</button>
          )}
          <button onClick={handleDownloadExcel} className="download-btn">Download Excel</button>
        </div>

        {data.length > 0 ? (
          <div className="card-slider">
            {data.filter((item) => Object.values(item).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))).map((item) => (
              <div
                className="data-card"
                key={item.id}
                style={{ backgroundColor: item.isShown == 0 ? '#e1e1e1' : 'white' }}
              >
                <div className="card-content-with-image">
                  <div className="card-details">
                    <h3>ID: {item.id}</h3>
                    {Object.keys(item)
                      .filter(key => !/^question(Type)?\d+$/.test(key) && !/^qmand\d+$/.test(key))
                      .map((key) => (
                        key !== 'id' && key.toLowerCase() !== 'isshown' && key.toLowerCase() !== 'created_at' && (
                          <div key={key} className="field-row">
                            <strong>{key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}:</strong>
                            {typeof item[key] === 'string' && /\.(jpe?g|png)$/i.test(item[key]) ? (
                              <a
                                href={`https://ethiccraft.org/${item[key]}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#007bff' }}
                              >
                                View
                              </a>
                            ) : key.includes('pdf') || item[key]?.includes('.pdf') ? (
                              <a
                                href={`https://ethiccraft.org/${formName === 'Certificates' && key === 'certificate_path'
                                  ? item[key].replace(/^.*?uploads\//, 'uploads/')
                                  : item[key]
                                  }`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#007bff' }}
                              >
                                View PDF
                              </a>
                            ) : (
                              (formName === 'Campus Ambassador' && key === 'portfolio') || (formName === 'User Profiles' && key === 'social_links') || (formName === 'Upcoming Events' && key === 'whatsapp_link') ? (
                                <a href={item[key]} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff' }}>
                                  {item[key]}
                                </a>
                              ) : (
                                <span dangerouslySetInnerHTML={{
                                  __html: String(item[key])
                                    .slice(0, 350)
                                    .replace(new RegExp(searchTerm, 'gi'), (match) => `<mark style='background:yellow'>${match}</mark>`) +
                                    (String(item[key]).length > 350 ? '..........' : '')
                                }}></span>
                              )
                            )}
                          </div>
                        )
                      ))}
                    {formName === 'Upcoming Events' && (
                      <>
                        {
                          [...Array(30)].map((_, i) => {
                            const q = `question${i + 1}`;
                            const t = `questionType${i + 1}`;
                            const m = `qmand${i + 1}`;
                            const value = item[q];

                            if (value) {
                              const type = item[t] ? `{${item[t]}}` : '{}';
                              const mandatory = item[m] !== undefined && item[m] !== null ? `{${item[m]}}` : '{}';

                              return (
                                <div key={q} className="field-row">
                                  <strong>Q{i + 1}:</strong>{' '}
                                  <span>
                                    {type} {mandatory} {value}
                                  </span>
                                </div>
                              );
                            }

                            return null;
                          })
                        }

                        {/* Show all null questions in one line */}
                        <div className="field-row">
                          <strong>Empty Fields:</strong>{' '}
                          <span>
                            {
                              [...Array(30)].map((_, i) => {
                                const q = `question${i + 1}`;
                                if (!item[q]) return `Q${i + 1}`;
                                return null;
                              }).filter(Boolean).join(', ')
                            }
                          </span>
                        </div>
                      </>
                    )}
                    {renderToggleButton &&
                      !['Campus Ambassador', 'Event Bookings', 'User Profiles'].includes(formName) && (
                        <div className="sticky-actions">
                          {typeof renderToggleButton === 'function' && item?.isShown !== undefined && (
                            renderToggleButton(item.id, item.isShown)
                          )}
                          {![
                            'Gallery',
                            'Activity Ethiccraft',
                            'Activity Hexagon',
                            'Activity Tiles',
                            'Alumni Ethiccraft',
                            'Camp Ethiccraft',
                            'Camp Highlights',
                            'Chapter Ethiccraft',
                            'Excellence',
                            'Campus Ambassador',
                            'Event Bookings',
                            'User Profiles',
                            'Certificates'
                          ].includes(formName) && (
                              <button onClick={() => handleEditClick(item)} className="row-btn">Edit</button>
                            )}
                          {formName === 'Upcoming Events' && renderOpenCloseButton(item.id, item.isOpen)}
                        </div>
                      )
                    }
                  </div>
                  <div className="card-image">
                    {Object.keys(item)
                      .filter((key) => typeof item[key] === 'string' && /\.(jpe?g|png)$/i.test(item[key]))
                      .map((imageKey) => (
                        <div className="image-wrapper" key={imageKey}>
                          <img
                            src={`https://ethiccraft.org/${item[imageKey]}`}
                            alt={imageKey}
                            className="right-image"
                          />
                          {!['User Profiles', 'Reports', 'Event Bookings', 'Campus Ambassador'].includes(formName) && (
                            <>
                              <label htmlFor={`file-input-${item.id}-${imageKey}`} className="image-overlay">
                                <img
                                  src="https://cdn-icons-png.flaticon.com/512/84/84380.png"
                                  alt="Edit"
                                  width="16"
                                  height="16"
                                  style={{ filter: 'invert(1)' }}
                                />
                                <span>Edit Image</span>
                              </label>
                              <input
                                id={`file-input-${item.id}-${imageKey}`}
                                type="file"
                                accept="image/*"
                                style={{ display: 'none' }}
                                onChange={(e) => {
                                  selectedImageField = imageKey;
                                  selectedImageId = item.id;
                                  handleImageUpdate(e);
                                }}
                              />
                            </>
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>No data available yet.</p>
        )}
      </div>
    </div>
  );
};

export default Formviewer;